import {CommonModule} from "@angular/common";
import {ModuleWithProviders, NgModule} from "@angular/core";
import {ReactiveFormsModule} from "@angular/forms";
import {PUBLIC_DIRECTIVES} from "./directives/public_directives";
import {DefaultErrorMessagesFactory, ErrorMessagesFactory} from "./services/error-messages-factory.service";
import {EmptyIconsFactory, NFrameworkIconsFactory} from "./services/nframework-icons-factory.service";
import {DatepickerConfig} from "./datepicker.config";
import {ENTRY_COMPONENTS, PRIVATE_COMPONENTS, PUBLIC_COMPONENTS} from "./components/components";
import {DEFAULT_THEME, N_THEME} from "./services/theme";
import {NPopoversModule} from "./n-popover/n-popovers.module";

@NgModule({
  declarations: [
    PUBLIC_COMPONENTS,
    PUBLIC_DIRECTIVES,
    PRIVATE_COMPONENTS
  ], // directives, components, and pipes owned by this NgModule
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NPopoversModule,
  ],
  exports: [
    PUBLIC_COMPONENTS,
    PUBLIC_DIRECTIVES,

    NPopoversModule
  ],
  providers: [
    DatepickerConfig
  ],
  entryComponents: [
    ENTRY_COMPONENTS
  ]
})
export class NControlsModule {
  static forRoot(): ModuleWithProviders<NControlsModule> {
    return {
      providers: [
        {provide: ErrorMessagesFactory, useClass: DefaultErrorMessagesFactory},
        {provide: NFrameworkIconsFactory, useClass: EmptyIconsFactory},
        {provide: N_THEME, useValue: DEFAULT_THEME}
      ],
      ngModule: NControlsModule
    };
  }
}
